import { Button } from "@mui/material";
import React, { useEffect, useContext } from "react";
import sun from "../../Img/sun.gif";
import moon from "../../Img/moon.gif";
import "./Darkmode.scss";
import { Sun } from "../../SvgCollection";
import { ThemeContext } from "./ThemeProvider";

function Darkmode() {
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);

  return (
    <div className="darkmode ml-10 cursor">
      <div className="d-flex" onClick={handleDarkmode}>
        {!isLightMode ? (
          // <img width="100" height="100" src="https://img.icons8.com/office/100/sun--v1.png" alt="sun--v1"/>
          <svg
            class="ICDarkMode_svg__icon"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="#F3F3F3"
          >
            <path d="M416.16 179.392c-140.8 33.568-245.504 160.192-245.504 311.296 0 176.736 143.264 320 320 320 151.072 0 277.696-104.704 311.296-245.504a273.44 273.44 0 01-385.76-385.76zM85.344 490.656c0-223.872 181.472-405.344 405.344-405.344 28.096 0 55.552 2.848 82.08 8.32a42.656 42.656 0 012.144 83.072A188.128 188.128 0 10804.576 406.4a42.656 42.656 0 0183.072 2.144c5.472 26.528 8.32 54.016 8.32 82.08 0 223.872-181.472 405.344-405.344 405.344S85.28 714.496 85.28 490.624z"></path>
          </svg>
        ) : (
          // <img width="30" height="30" src="https://img.icons8.com/emoji/30/crescent-moon-emoji.png" alt="crescent-moon-emoji"/>
          <svg
            class="ICLightMode_svg__icon"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="#1D1D1D"
          >
            <path d="M554.656 85.312a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64zm-374.56 94.784a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zM42.656 512c0-23.552 19.104-42.656 42.656-42.656h64a42.656 42.656 0 010 85.312h-64A42.656 42.656 0 0142.656 512zm243.072 286.592a42.656 42.656 0 10-60.352-60.352l-45.248 45.248a42.656 42.656 0 1060.352 60.352l45.248-45.248zm452.544-60.256a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zm136.384-269.024a42.656 42.656 0 000 85.312h64a42.656 42.656 0 000-85.312h-64zM843.872 180.16a42.656 42.656 0 010 60.352l-45.248 45.248a42.656 42.656 0 11-60.352-60.352l45.248-45.248a42.656 42.656 0 0160.352 0z"></path>
            <path d="M225.536 512A286.496 286.496 0 11512 798.496 286.464 286.464 0 01225.536 512zM512 310.848a201.152 201.152 0 100 402.304 201.152 201.152 0 000-402.304zm42.656 563.872a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64z"></path>
          </svg>
        )}
      </div>
    </div>
  );
}

export default Darkmode;
